import { useCopilotAction } from "@copilotkit/react-core";
import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { COPILOT_ACTIONS } from "../constants/actions";
import { getCopilotAction } from "../helpers";
import { COPILOT_CHOICES } from "../instructions/choices";
import type { ActionExecutionResult } from "../renderers";

export const useRcMatchEmail = () => {
	const { newUserInfo } = useAuthContext();

	useCopilotAction({
		...getCopilotAction(COPILOT_ACTIONS.MATCH_EMAIL),
		parameters: [
			{
				name: "userProvidedEmail",
				type: "string",
				description: "The email provided by the user",
			},
		],
		handler: ({ userProvidedEmail }): ActionExecutionResult => {
			if (newUserInfo?.email === userProvidedEmail) {
				return {
					type: "success",
					message: "Email matched.",
					instructions: COPILOT_CHOICES.EMAIL_MATCH_SUCCESS,
				};
			}

			return {
				type: "error",
				message: "Email did not match.",
				instructions: COPILOT_CHOICES.EMAIL_MATCH_ERROR,
			};
		},
	});
};
